import React from "react";
import DownloadSection from "../components/DownloadSection";

const DownloadsPage = () => {
  return (
    <main className="bg-[#0a0a0d] min-h-screen">
      <div className="relative pt-44 pb-8 overflow-hidden">
        <div
          className="absolute inset-0 opacity-25"
          style={{
            backgroundImage: "url(https://images.unsplash.com/photo-1585588985526-9459c1bb9e9e?auto=format&fit=crop&w=1920&q=80)",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0d]/50 via-[#0a0a0d]/85 to-[#0a0a0d]" />
      </div>
      <DownloadSection />
    </main>
  );
};

export default DownloadsPage;
